<template>
  <custom-dialog :title="dialogObj.title || '收费'" :showClose="true" width="400px" v-if="visibleObj.howmuchDialog"
    :visible="visibleObj.howmuchDialog" @close="dialogVisible('howmuchDialog')">
    <div class="content" slot="content">
      <div class="text">{{ dialogObj.text ||  '请扫描顾客二维码'}}</div>
      <div class="content-price"><span class="price-icon" v-if="dialogObj.price">¥</span>{{ dialogObj.price }}</div>
      <img :src="imgArr.howmuch" class="haomuch-img">
      <el-input class="hide-section" ref="codeInput"></el-input>
    </div>
    <div class="btn" slot="footer">
      <custom-button
        v-if="showCancelPayBtn"
        type="info"
        style="width: 100px;"
        slot="footer"
        @click="cancelPayingStatusHandle"
      >取消支付</custom-button>

      <custom-button
        type="info"
        style="width: 100px;"
        slot="footer"
        @click="dialogVisible('howmuchDialog')"
      >取消</custom-button>
        
    </div>
  </custom-dialog>
</template>

<script>
import customDialog from '@/components/customDialog/CustomDialog'
import { imgArr } from '@/assets/images/img'
import { scan } from '@/utils/scan'
export default {
  // 定义引入的组件
  components: { customDialog },
  props: {
    visibleObj: {
      type: Object,
      default: {}
    },
    dialogObj: {
      type: Object,
      default: {}
    },
    // 是否显示取消收费中按钮
    showCancelPayBtn: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      imgArr: imgArr,
      payQrCode: '',//支付码
      lastInputTime: null
    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  created() {
    this.payQrCode = ''
    this.$nextTick(() => {
      this.$refs['codeInput'].focus();
      this.keyDownFn()
    })
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  beforeDestroy() {
    window.onkeydown = null;
  },
  // 页面方法
  methods: {
    /**
     * 关闭
     */
    dialogVisible(name) {
      this.$emit("close", name);
    },
    // 获取扫码code
    getCode(value) {
      this.payQrCode = value;
      if (!!value) {
        this.$message.success('扫码成功！')
        setTimeout(() => {
          this.$emit('updateData', { payWay: 3, userAuthCode: this.payQrCode, price: this.dialogObj.price })
        }, 100)
      }
    },
    keyDownFn() {
      let that = this
      window.onkeydown = async function (e) {
        that.operateCode(e)
      }
    },
    async operateCode(e) {
      let isBol = (e.keyCode == 13) && !!this.payQrCode
      if (isBol) {
        console.log('----扫码----', this.payQrCode)
        this.$emit('updateData', { payWay: 3, userAuthCode: this.payQrCode, price: this.dialogObj.price })
        return
      }
      let params = {
        key: e.key,
        code: this.payQrCode,
        lastInputTime: this.lastInputTime,
      }
      let _o = await scan.getCode(params)
      this.payQrCode = _o.code
      this.lastInputTime = _o.lastInputTime
    },
    // 取消支付中的状态
    cancelPayingStatusHandle() {
      this.$emit('cancelPayingStatusHandle')
    }
  },
}
</script>
<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .hide-section {
    opacity: 0;
  }

  .text {
    color: #1F2329;
    font-size: 14px;
    margin-bottom: 14px;
    font-weight: 500;
  }

  .content-price {
    color: #FE8F1F;
    font-size: 24px;
    font-weight: bold;

    .price-icon {
      font-size: 16px;
      margin-right: 4px;
    }
  }

  .haomuch-img {
    width: 100px;
    height: 100px;
    flex-flow: 0;
    flex-grow: 0;
    margin-top: 12px;
  }
}

.btn {
  text-align: center;
  padding-bottom: 16px;
}
</style>